import React, { createContext, useReducer } from 'react'
import PropTypes from 'prop-types'
import { types } from '../constants/types'
import { authReducer } from './authReducer'

export const AuthContext = createContext()

const initialState = {
  logged: false,
}

const init = () => {
  const auth = JSON.parse(localStorage.getItem('auth'))

  return {
    logged: !!auth,
    auth: auth,
  }
}

export const AuthProvider = ({ children }) => {
  const [authState, dispatch] = useReducer(authReducer, initialState, init)

  const login = (auth) => {
    const action = {
      type: types.login,
      payload: auth,
    }

    localStorage.setItem('auth', JSON.stringify(auth))
    dispatch(action)
  }

  const logout = () => {
    localStorage.removeItem('auth')
    const action = { type: types.logout }
    dispatch(action)
  }

  return (
    <AuthContext.Provider value={{ ...authState, login, logout }}>{children}</AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
